<div class="flex-utility align-center" *ngIf="isVisible">
  <div class="button-container">
    <div *ngIf="columnViewerService.hiddenCounter > 0" class="counter">
      {{columnViewerService.hiddenCounter}}
    </div>
    <app-bulgari-button [customStyle]="'height: 40px;'" [full]="true" [type]="'column-visibility'"
      [text]="'BUTTON.COLUMN_VISIBILITY' | translate" [matMenuTriggerFor]="menu">
      <i class="material-icons">menu</i>
    </app-bulgari-button>
    <mat-menu #menu="matMenu" [hasBackdrop]="true">
      <div class="row-menu all-columns" (click)="columnViewerService.showAllColumns()">
        <span class="text-label"> {{ "SHOW_ALL_COLUMNS" | translate }} </span>
      </div>
      <div *ngFor="let col of columns;let i = index" class="row-menu" (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()">
        <input class="custom-checkbox" type="checkbox" [checked]="columnViewerService.isVisibleColumn(col.key)"
          (change)="updateColumn(col.key)">
        <span class="text-label"> {{ col.label | translate }} </span>
      </div>
    </mat-menu>
  </div>
</div>
